import { render, staticRenderFns } from "./IconPickerControl.vue?vue&type=template&id=0df31b54&scoped=true"
import script from "./IconPickerControl.vue?vue&type=script&lang=js"
export * from "./IconPickerControl.vue?vue&type=script&lang=js"
import style0 from "./IconPickerControl.vue?vue&type=style&index=0&id=0df31b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df31b54",
  null
  
)

export default component.exports